module.exports = __webpack_public_path__ + "assets/static/png/logo.5df53c6919f66d2323b6e0192054a6aa.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/header/images/logo.png
 ** module id = 485
 ** module chunks = 1
 **/